import PropTypes from 'prop-types';

export const deliveryAddressPropType = PropTypes.shape({
    zip: PropTypes.string,
    id: PropTypes.string,
    street: PropTypes.string,
    streetNumber: PropTypes.number,
    entrance: PropTypes.string,
    flat: PropTypes.number,
    floor: PropTypes.number,
    floorType: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    co: PropTypes.string,
    deliveryPointId: PropTypes.string,
});

export const deliveryPropType = PropTypes.shape({
    id: PropTypes.string,
    days: PropTypes.string,
    address: deliveryAddressPropType,
    subscriptionNumber: PropTypes.string,
    success: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    type: PropTypes.string,
    status: PropTypes.string,
});

export const subscriptionDeliveryPropType = PropTypes.shape({
    success: PropTypes.bool.isRequired,
    address: PropTypes.shape({
        city: PropTypes.string,
        country: PropTypes.string,
        entrance: PropTypes.string,
        flat: PropTypes.number,
        floor: PropTypes.number,
        floorType: PropTypes.string,
        id: PropTypes.string,
        street: PropTypes.string,
        streetNumber: PropTypes.number,
        zip: PropTypes.string,
    }),
    days: PropTypes.string,
    id: PropTypes.string,
    startDate: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    valid: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.string),
});
